import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index.js'
import {getUserLogin} from '@/script/apiService/api.js'

let root = process.env.VUE_APP_PACACLOUND_ROOT;

Vue.use(VueRouter);

const routes = [
  {
    path: `${root}`,
    name: "Home",
    redirect: { name: 'ServiceSummary' }
  },
  {
    path: `${root}/public/terms`,
    name: "Terms",
    component: () => {
      return import("@/view/public/terms.vue")
    }
  },
  {
    path: `${root}/public/privacy`,
    name: "Privacy",
    component: () => {
      return import("@/view/public/privacy.vue")
    }
  },
  {
    path: `${root}/login`,
    name: "Login",
    redirect: { name: 'Production' }
  },
  {
    path: `${root}/login/production`,
    name: "Production",
    component: () => {
      return import("@/view/login/production.vue")
    }
  },
  {
    path: `${root}/service/summary`,
    name: "ServiceSummary",
    component: () => {
      return import("@/view/service/summary.vue")
    }
  },
  {
    path: `${root}/service/site`,
    name: "UserSite",
    component: () => {
      return import("@/view/service/site.vue")
    }
  },
  {
    path: `${root}/service/apiToken`,
    name: "UserToken",
    component: () => {
      return import("@/view/service/token.vue")
    }
  },
  {
    path: `${root}/report/ntpReport`,
    name: "NtpReport",
    component: () => {
      return import("@/view/report/ntpReport.vue")
    }
  },
  {
    path: `${root}/account/info`,
    name: "AccountInfo",
    component: () => {
      return import("@/view/account/accountInfo.vue")
    }
  },
  {
    path: `${root}*`,
    redirect: {name: 'Home'}
  }
]
const router = new VueRouter({
  mode: 'history',
  routes
})
let checkTokenTimeOnce = async function(){
  let res = await getUserLogin();
  if(!res.error_status){
    if(res.is_partner == 1){
      store.commit({
        type: "setUserInfo",
        userInfo: null
      })
      return false;
    } else {
      res.api_token = store.state.userInfo.api_token;
      store.commit({
        type: "setUserInfo",
        userInfo: res
      })
    }
  }
  checkTokenTimeOnce = function(){};
}
router.beforeEach(async (to,from,next) => {
  if(window.innerWidth < 769){
    store.commit({
      type: 'setAsideCollapseButton',
      isOpen: false
    })
  }
  if(to.path == `${root}/public/terms` || to.path == `${root}/public/privacy`){
    next();
  }else{
    if(to.path != `${root}/logout` && store.state.userInfo){
      await checkTokenTimeOnce();
    }
    if(to.path.indexOf(`${root}/login`) == -1 && !store.state.userInfo){
      next(`${root}/login`);
    }else if(to.path.indexOf(`${root}/login`) != -1 && !store.state.userInfo){
      next();
    }else if(to.path.indexOf(`${root}/login`) != -1 && store.state.userInfo){
      next(from);
    }else{
      next();
    }
  }
})

export default router;
